import { createStore } from 'zustand';
import type { StoreApi } from 'zustand';

import type { SearchContextType } from '../../types';

export const INITIAL_SEARCH_CONTEXT_STATE: SearchContextType = {
  count: 0,
  filters: {},
  listLength: 0,
  loading: true,
  loadMore: () => undefined,
  results: [],
  searchPageSize: 0,
  searchParams: {},
  setSearchParams: () => undefined,
  resetFilters: () => undefined,
  viewerId: '',
};

export const createSearchStore = (
  initialState: SearchContextType = INITIAL_SEARCH_CONTEXT_STATE
): StoreApi<SearchContextType> => {
  return createStore<SearchContextType>()(() => initialState);
};
